var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-card-header',[_c('b-row',[_c('b-col',{attrs:{"md":"9"}},[_c('h3',[_vm._v("Calendário")])])],1)],1),_vm._v(" "),_c('b-card-body',[_c('FullCalendar',{attrs:{"defaultView":"dayGridMonth","plugins":_vm.calendarPlugins,"locale":_vm.locale,"firstDay":_vm.firstDay,"titleFormat":_vm.titleFormat,"events":_vm.events,"eventRender":_vm.ticketEventRender,"displayEventTime":_vm.displayEventTime,"displayEventEnd":_vm.displayEventEnd,"eventTimeFormat":_vm.eventTimeFormat},on:{"datesRender":_vm.handleMonthChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/site/interna/administrador/usuarios/voluntario/Calendario.vue?vue&type=template&id=3dee9a00&
// module id = null
// module chunks = 